const ServiceMenuData = [
  {
    mainMenu: "Staff Augmentation",
    subMenuGroup: [
      {
        submenu: "Staff Augmentation & Dedicated Teams",
        route: "/services/staffAugmentation",
      },
    ],
  },
  {
    mainMenu: "Web Development",
    subMenuGroup: [
      {
        submenu: "Web Design",
        route: "/services/webDesign",
      },
      {
        submenu: "PSD To HTML",
        route: "/services/psdToHtml",
      },
      {
        submenu: "Custom Design",
        route: "/services/customWebDesign",
      },
      {
        submenu: "Web Development",
        route: "/services/webAppDevelopment",
      },
      {
        submenu: "App Development",
        route: "/services/appDev",
      },
      {
        submenu: "Wordpress Website",
        route: "/services/wordpressWebsite",
      },
      {
        submenu: "Ecommerce Website",
        route: "/services/ecommerceWebsite",
      },
      {
        submenu: "Shopify Website",
        route: "/services/shopifyDevelopment",
      },
      {
        submenu: "Woo Commerce Website",
        route: "/services/wooCommerceDevelopment",
      },
    ],
  },
  {
    mainMenu: "Graphic Design",
    subMenuGroup: [
      {
        submenu: "Logo Design",
        route: "/services/logoDesign",
      },
      {
        submenu: "Social Media Design",
        route: "/services/branding",
      },
      {
        submenu: "Stationery Design",
        route: "/services/stationeryDesign",
      },
      {
        submenu: "Ads Design",
        route: "/services/adsDesign",
      },
      {
        submenu: "Videos & Animation",
        route: "/services/videoAnimation",
      },
      {
        submenu: "UI/UX",
        route: "/services/uiUxDesign",
      },
    ],
  },
  {
    mainMenu: "Web Solutions",
    subMenuGroup: [
      {
        submenu: "Web Hosting",
        route: "/services/hosting",
      },
      {
        submenu: "SSL Certificates",
        route: "/services/sslCertificate",
      },
      {
        submenu: "SEO Services",
        route: "/services/seo",
      },
      {
        submenu: "Website Maintenance",
        route: "/services/websiteMaintance",
      },
    ],
  },
  {
    mainMenu: "Other",
    subMenuGroup: [
      {
        submenu: "NFT Project Website",
        route: "/contact-us",
      },
      {
        submenu: "Blockchain Development",
        route: "/contact-us",
      },
    ],
  },
];

export default ServiceMenuData;
